import { GridConfig } from "../defaults";

export const sfDefaultGrid: GridConfig = {
  AlgoOrderID: 3,
  UseAlgoOrder: true,
  Hotkey: "Ctrl+3",
  Side: "Neutral",
  TimeInForce: "GTX",
  BidTotalSize: 5000.0,
  BidSizeRandomRate: 0.0,
  BidSizeScaleType: "Hyperbolic",
  BidSizeScaleDirection: "Up",
  AskTotalSize: 5000.0,
  AskSizeRandomRate: 0.0,
  AskSizeScaleType: "Hyperbolic",
  AskSizeScaleDirection: "Up",
  OrdersNumber: 10,
  LowerRangeBasis: "LinReg",
  ConstantLowerRangeBasis: 0.0,
  LowerRangeBasisMultiplier: 1.0,
  LowerRangeOffset: "StDev",
  LowerRangeOffsetMultiplier: -3.0,
  UpperRangeBasis: "LinReg",
  ConstantUpperRangeBasis: 0.0,
  UpperRangeBasisMultiplier: 1.0,
  UpperRangeOffset: "StDev",
  UpperRangeOffsetMultiplier: 3.0,
  StartOrderDistance: "Tick",
  StartOrderDistanceMultiplier: 1.0,
  StopOrderDistance: "Tick",
  StopOrderDistanceMultiplier: 1.0,
  CancelDistance: "StDev",
  LowerRangeCancelDistanceMultiplier: 0.25,
  UpperRangeCancelDistanceMultiplier: 0.25,
  MinRangeDistance: "Percent",
  MinRangeDistanceMultiplier: 1.0,
  MaxRangeDistance: "Percent",
  MaxRangeDistanceMultiplier: 50.0,
  MinZScore: -10.0,
  MaxZScore: 10.0,
  WaitTime: 0.0,
  WaitTimeRandomRate: 0.0,
  RefreshTime: 1000.0,
  RefreshTimeRandomRate: 0.0,
  RefreshNumber: 3600,
  RefreshNumberRandomRate: 0.0,
  PauseTime: 0.0,
  PauseTimeRandomRate: 0.0,
  AutoContinuation: true,
};
